import { render, staticRenderFns } from "./LoanFee.vue?vue&type=template&id=3d460890&"
import script from "./LoanFee.vue?vue&type=script&lang=js&"
export * from "./LoanFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports